import { writable } from "svelte/store";
let StagedRolloutStore;
export default StagedRolloutStore = writable({});
